module.exports = __webpack_public_path__ + "static/media/VestasSans-Standard.9e95e5e2.woff";